import React from 'react';
import { css } from '@emotion/react';
import AdSlot from '@gumtree/third-party-ads/display-ad-slot';
import { DisplayAdSlotDivNames } from '@gumtree/third-party-ads/src/framework/dfp/ad-config/slot-configs';

const StickyAdsColumn = () => {
    return (
        <div>
            <AdSlot
                id={DisplayAdSlotDivNames.mpu}
                css={css`
                    position: sticky;
                    top: 0;
                    min-height: 250px;
                    text-align: center;
                `}
            />
        </div>
    );
};

export default StickyAdsColumn;
